// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__gMKap","header":"Messages_header__18wbf"};